import axios from 'axios';
import Cookies from 'js-cookie';

export const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}`,
});

// Перехватчик запросов для правильной обработки FormData
axiosInstance.interceptors.request.use((config) => {
  // Если данные являются FormData, не устанавливаем Content-Type
  // Браузер автоматически установит правильный Content-Type с boundary
  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  }
  return config;
});

axiosInstance.interceptors.response.use(
  async function (response) {
    if (response.data.success === true) {
      return response.data.value;
    } else {
      if (response.data.code === 401) {
        Cookies.remove('sid');
        Cookies.remove('refreshToken');
        Cookies.remove('expiredAt');
        window.location.assign('/login');
      }

      if (response.data.code === 404 && response.data.error === 'Токен в системе не найден') {
        Cookies.remove('sid');
        Cookies.remove('refreshToken');
        Cookies.remove('expiredAt');
        window.location.assign('/login');
      }

      if (response.data.code === 403) {
        if (
          response.data.error === 'Сессия была деактивирована' ||
          response.data.error === 'У пользователя нет доступа в администраторскую панель'
        ) {
          Cookies.remove('sid');
          Cookies.remove('refreshToken');
          Cookies.remove('expiredAt');
          window.location.assign(
            response.data.error === 'У пользователя нет доступа в администраторскую панель'
              ? '/403'
              : '/login',
          );
        }
      }
      throw response.data;
    }
  },
  function (error) {
    return Promise.reject(error);
  },
  null,
  { synchronous: false },
);
